import React from "react";
import { PrismicNextImage } from "@prismicio/next";

const Images = ({ images }) => {
  return (
    <div className="px-[16px] md:px-[40px] xl:px-0 mx-auto flex flex-col md:flex-row md:justify-center -mt-[220px] md:-mt-[70px] xl:-mt-[120px] w-full  xl:max-w-[1050px]">
      {images?.map((item, id) => (
        <div key={id}>
          <PrismicNextImage
            field={item?.image}
            fallbackAlt=""
            className="h-[155px] object-cover md:h-auto mx-auto"
          />
        </div>
      ))}
    </div>
  );
};

export default Images;
